import { API_ENDPOINT, useJwtToken } from 'helper';
import { useQuery } from 'react-query';

export const useAvailableFirmware = (Thing_ID) => {
    const accessToken = useJwtToken();
    return useQuery(
        ['availableFirmware', Thing_ID],
        () => fetchAvailableFirmware(Thing_ID, accessToken),
        {
            enabled: !!Thing_ID && !!accessToken,
            refetchOnReconnect: false,
        }
    );
};

export const fetchAvailableFirmware = async (Thing_ID, accessToken) => {
    const url = new URL(`${API_ENDPOINT}/firmware`);
    url.searchParams.set('Thing_ID', Thing_ID);

    try {
        const response = await fetch(url.toString(), {
            method: 'GET',
            headers: {
                Authorization: accessToken,
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching available firmware:', error);
        throw error;
    }
};

export const updateFirmware = async (
    Thing_ID,
    FirmwarePackage_ID,
    accessToken
) => {
    const url = new URL(`${API_ENDPOINT}/firmware`);
    try {
        const response = await fetch(url.toString(), {
            method: 'POST',
            headers: {
                Authorization: accessToken,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                FirmwarePackage_ID,
                Thing_ID,
            }),
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(
                `Error status: ${response.status} - ${error.message}`
            );
        }

        return await response.json();
    } catch (error) {
        throw error;
    }
};
